(function () {
  'use strict';

  // ~100 curated, engraving-friendly Google fonts (clean scripts, serifs, sans).
  // Decorative/hairline/symbol fonts are intentionally excluded — they engrave poorly.
  var FONTS = [
    // Scripts / calligraphy
    'Great Vibes', 'Allura', 'Alex Brush', 'Dancing Script', 'Sacramento', 'Satisfy',
    'Pacifico', 'Tangerine', 'Pinyon Script', 'Parisienne', 'Yellowtail', 'Kaushan Script',
    'Courgette', 'Niconne', 'Cookie', 'Petit Formal Script', 'Marck Script', 'Norican',
    'Clicker Script', 'Mr Dafoe', 'Carattere', 'Rouge Script', 'Italianno', 'Engagement',
    'Bilbo', 'Mrs Saint Delafield', 'Herr Von Muellerhoff', 'Lovers Quarrel',
    'Monsieur La Doulaise', 'Mr De Haviland', 'Style Script', 'Ephesis', 'Birthstone',
    'Whisper', 'Meddon',
    // Handwritten
    'Caveat', 'Shadows Into Light', 'Indie Flower', 'Amatic SC', 'Permanent Marker',
    'Kalam', 'Patrick Hand', 'Gochi Hand', 'Architects Daughter', 'Reenie Beanie',
    'Nanum Pen Script', 'Homemade Apple',
    // Serif
    'Playfair Display', 'Cormorant Garamond', 'EB Garamond', 'Cormorant', 'Cinzel',
    'Cinzel Decorative', 'Libre Baskerville', 'Crimson Text', 'Crimson Pro', 'Abril Fatface',
    'DM Serif Display', 'Prata', 'Marcellus', 'Marcellus SC', 'Italiana', 'Spectral',
    'Vollkorn', 'Alegreya', 'Lora', 'PT Serif', 'Bodoni Moda', 'Yeseva One', 'Merriweather',
    'Cardo', 'Sorts Mill Goudy', 'Old Standard TT', 'Forum', 'Tinos', 'Gilda Display',
    'Bellefair',
    // Sans
    'Montserrat', 'Poppins', 'Raleway', 'Josefin Sans', 'Quicksand', 'Comfortaa', 'Oswald',
    'Bebas Neue', 'Anton', 'Archivo', 'Questrial', 'Jost', 'Sora', 'Nunito', 'Rubik',
    'Work Sans', 'Manrope', 'DM Sans', 'Mulish', 'Cabin', 'Tenor Sans', 'Julius Sans One',
    'Maven Pro'
  ];

  // Per-shape text fit: w = width fill per line (line1, line2, line3+), h = max
  // share of the tag height the stacked text may use. Tuned to each silhouette's
  // usable engraving area (heart = upper lobes, bone = middle shaft).
  var FIT = {
    round:   { w: [0.75, 0.7, 0.65], h: 0.75 },
    rounded: { w: [0.8, 0.75, 0.7], h: 0.8 },
    heart:   { w: [0.52, 0.48, 0.44], h: 0.42 },
    bone:    { w: [0.82, 0.74, 0.68], h: 0.5 }
  };

  var loaded = {};
  function loadFonts(families) {
    var batch = [];
    families.forEach(function (f) {
      if (f && !loaded[f]) { loaded[f] = true; batch.push(f); }
    });
    for (var i = 0; i < batch.length; i += 18) {
      var group = batch.slice(i, i + 18);
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?' +
        group.map(function (f) {
          return 'family=' + encodeURIComponent(f).replace(/%20/g, '+');
        }).join('&') + '&display=swap';
      document.head.appendChild(link);
    }
  }

  function clampText(value, maxLines, maxChars) {
    var lines = value.replace(/\r/g, '').split('\n').slice(0, maxLines);
    lines = lines.map(function (l) { return l.slice(0, maxChars); });
    return lines.join('\n');
  }

  if (!('customElements' in window)) return;

  customElements.define('engraving-personalizer', class extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      var el = this;
      this.maxLines = parseInt(this.dataset.maxLines, 10) || 3;
      this.maxChars = parseInt(this.dataset.maxChars, 10) || 15;
      this.variantSync = this.dataset.variantSync || '';
      this.sectionId = this.dataset.section || '';
      this.frontRequired = this.dataset.frontRequired !== 'false';
      this.fieldAWrap = this.querySelector('[data-field="a"]');
      this.fieldBWrap = this.querySelector('[data-field="b"]');
      this.front = this.fieldAWrap ? this.fieldAWrap.querySelector('textarea') : null;
      this.back = this.fieldBWrap ? this.fieldBWrap.querySelector('textarea') : null;
      this.previewText = this.querySelector('[data-preview-text]');
      this.previewPlate = this.querySelector('[data-preview-plate]');
      this.previewShape = this.dataset.previewShape || 'plate';
      this.isProof = this.previewShape !== 'plate';
      this.fontDropdown = this.querySelector('[data-font-dropdown]');
      this.previewFamily = 'Marcellus';

      [this.front, this.back].forEach(function (ta) {
        if (!ta) return;
        ta.addEventListener('input', function () {
          var clamped = clampText(ta.value, el.maxLines, el.maxChars);
          if (clamped !== ta.value) ta.value = clamped;
          el.updateCounter(ta);
          el.updatePreview();
        });
        el.updateCounter(ta);
      });

      // Variant-driven field visibility: recompute whenever a variant option changes.
      if (this.variantSync) {
        document.addEventListener('change', function (e) {
          if (e.target.closest && e.target.closest('variant-selects, variant-radios')) {
            el.applyVariantSync();
          }
        });
        this.applyVariantSync();
      }

      // Custom font dropdown (scrollable, capped height).
      if (this.fontDropdown) {
        var trigger = this.fontDropdown.querySelector('[data-font-trigger]');
        var triggerLabel = this.fontDropdown.querySelector('[data-font-trigger-label]');
        var list = this.fontDropdown.querySelector('[data-font-list]');
        var valueInput = this.fontDropdown.querySelector('[data-font-value]');

        var frag = document.createDocumentFragment();
        FONTS.forEach(function (f) {
          var li = document.createElement('li');
          li.className = 'engraving__font-option';
          li.setAttribute('role', 'option');
          li.dataset.value = 'Custom: ' + f;
          li.dataset.previewFont = f;
          li.textContent = f;
          li.style.fontFamily = "'" + f + "'";
          frag.appendChild(li);
        });
        list.appendChild(frag);

        var selOpt = list.querySelector('.engraving__font-option.is-selected');
        if (selOpt) this.previewFamily = selOpt.dataset.previewFont || 'Marcellus';

        loadFonts(['Marcellus', 'Pinyon Script']);
        var loadedAll = false;
        var openList = function () {
          if (!loadedAll) { loadedAll = true; loadFonts(FONTS); }
          list.hidden = false;
          trigger.setAttribute('aria-expanded', 'true');
        };
        var closeList = function () {
          list.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
        };

        trigger.addEventListener('click', function (e) {
          e.stopPropagation();
          if (list.hidden) openList(); else closeList();
        });
        list.addEventListener('click', function (e) {
          var li = e.target.closest('.engraving__font-option');
          if (!li) return;
          list.querySelectorAll('.engraving__font-option').forEach(function (o) {
            o.classList.remove('is-selected');
          });
          li.classList.add('is-selected');
          valueInput.value = li.dataset.value;
          triggerLabel.textContent = li.textContent;
          triggerLabel.style.fontFamily = li.style.fontFamily;
          el.previewFamily = li.dataset.previewFont || li.textContent;
          loadFonts([el.previewFamily]);
          closeList();
          el.updatePreview();
        });
        document.addEventListener('click', function (e) {
          if (!el.fontDropdown.contains(e.target)) closeList();
        });
      }

      // Proof mode (round/rounded tags): refit text on resize and once webfonts settle.
      if (this.isProof) {
        var refit = function () { el.fitText(); };
        window.addEventListener('resize', refit);
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(refit);
        }
      }

      this.updatePreview();
    }

    readVariant() {
      var picker = (this.sectionId && document.querySelector(
        'variant-selects[data-section="' + this.sectionId + '"], variant-radios[data-section="' + this.sectionId + '"]'
      )) || document.querySelector('variant-selects, variant-radios');
      if (!picker) return '';
      var vals = [];
      picker.querySelectorAll('select').forEach(function (s) { if (s.value) vals.push(s.value); });
      picker.querySelectorAll('input[type="radio"]:checked').forEach(function (r) { if (r.value) vals.push(r.value); });
      return vals.join(' / ');
    }

    applyVariantSync() {
      if (!this.variantSync) return;
      var vals = this.readVariant();
      var showA = true, showB = false;
      if (this.variantSync === 'back') {
        showA = !!this.front;
        showB = /both|back/i.test(vals);
      } else if (this.variantSync === 'in_out') {
        if (/both/i.test(vals)) { showA = true; showB = true; }
        else if (/outside/i.test(vals)) { showA = false; showB = true; }
        else { showA = true; showB = false; }
      }
      this.setFieldVisible(this.fieldAWrap, this.front, showA, this.frontRequired);
      this.setFieldVisible(this.fieldBWrap, this.back, showB, true);
      this.updatePreview();
    }

    setFieldVisible(wrap, ta, visible, requiredWhenVisible) {
      if (!wrap || !ta) return;
      wrap.hidden = !visible;
      ta.disabled = !visible;
      ta.required = !!(visible && requiredWhenVisible);
    }

    updateCounter(ta) {
      var counter = this.querySelector('[data-counter-for="' + ta.dataset.engravingText + '"]');
      if (!counter) return;
      var lines = ta.value ? ta.value.split('\n').length : 0;
      counter.textContent = lines + '/' + this.maxLines + ' lines';
    }

    primaryField() {
      if (this.front && !this.front.disabled) return this.front;
      if (this.back && !this.back.disabled) return this.back;
      return this.front || this.back;
    }

    updatePreview() {
      if (!this.previewText) return;
      var src = this.primaryField();
      var text = src ? src.value : '';
      this.previewText.style.fontFamily = "'" + this.previewFamily + "', cursive";

      if (!text) {
        this.previewText.innerHTML = this.isProof
          ? '<div class="engraving__pv-line is-primary">Your text</div>'
          : '<div>Your text here</div>';
        if (this.isProof) this.fitText();
        return;
      }

      // First line is the headline (e.g. the pet's name); later lines are supporting
      // detail (phone number, etc.) and render smaller — like a real engraving proof.
      this.previewText.innerHTML = text.split('\n').map(function (l, i) {
        var div = document.createElement('div');
        div.className = 'engraving__pv-line' + (i === 0 ? ' is-primary' : '');
        div.textContent = l || ' ';
        return div.outerHTML;
      }).join('');

      if (this.isProof) {
        var self = this;
        this.fitText();
        // Re-fit after the chosen webfont swaps in (metrics change on load).
        setTimeout(function () { self.fitText(); }, 120);
      }
    }

    // Engraving proof: each line is sized independently to fill ~85% of the tag
    // width, so a short name renders large and a longer phone number renders
    // smaller underneath. A second pass scales everything down if the stacked
    // lines would exceed 85% of the tag height.
    fitText() {
      var plate = this.previewPlate, block = this.previewText;
      if (!plate || !block) return;
      var lines = block.querySelectorAll('.engraving__pv-line');
      if (!lines.length) return;

      var cfg = FIT[this.previewShape] || FIT.round;
      var fillByLine = cfg.w;
      var W = plate.clientWidth, availH = plate.clientHeight * cfg.h;

      var sizes = [];
      lines.forEach(function (line, i) {
        line.style.fontSize = '100px';
        var w = line.scrollWidth;
        if (!w) { sizes[i] = 10; return; }
        var availW = W * (fillByLine[i] || fillByLine[fillByLine.length - 1]);
        // Fill the width; cap so a 1–2 char line can't grow taller than the tag.
        sizes[i] = Math.max(10, Math.min(100 * (availW / w), availH));
      });

      // Cap line 3+ at line 2's size, so a short last line (e.g. 2 letters under
      // a name + phone number) doesn't balloon larger than the line above it.
      if (sizes.length > 2) {
        for (var i = 2; i < sizes.length; i++) {
          sizes[i] = Math.min(sizes[i], sizes[1]);
        }
      }

      lines.forEach(function (line, i) { line.style.fontSize = sizes[i] + 'px'; });

      var totalH = block.scrollHeight;
      if (totalH > availH) {
        var k = availH / totalH;
        lines.forEach(function (line) {
          line.style.fontSize = (parseFloat(line.style.fontSize) * k) + 'px';
        });
      }
    }
  });
})();
